import { FormattedMessage, FormattedNumber } from 'react-intl';

import { Constants } from '@arrived/common';
import { OfferingId } from '@arrived/models';
import { MAX_STALE_TIME, useOfferingQuery } from '@arrived/queries';

export interface OfferingSharePriceProps {
  offeringId: OfferingId;
}

export const OfferingSharePrice = ({ offeringId }: OfferingSharePriceProps) => {
  const offeringState = useOfferingQuery(offeringId, { staleTime: MAX_STALE_TIME });

  switch (offeringState.status) {
    case 'loading':
      return <FormattedMessage id="loading" defaultMessage="Loading..." />;
    case 'error':
      return <>-</>;
    case 'success':
      return (
        <FormattedMessage
          id="price-per-share"
          defaultMessage="{sharePrice}/share"
          values={{
            sharePrice: (
              <FormattedNumber
                style="currency"
                currency="USD"
                value={Constants.sharePriceUpdatedOfferings.includes(offeringId) ? offeringState.data.sharePrice : 10}
              />
            ),
          }}
        />
      );
  }
};
